<div class="billing-page">
  <div class="billing-header">
    <div>
      <span class="eyebrow">Wartung kaufmännisch</span>
      <h1>Abrechnung</h1>
      <p>Offene Einsätze prüfen, Preise ergänzen und Rechnungen vorbereiten.</p>
    </div>
    <div class="filter-buttons">
      <button mat-stroked-button [class.active]="filter === 'open'" (click)="setFilter('open')">Offen</button>
      <button mat-stroked-button [class.active]="filter === 'billed'" (click)="setFilter('billed')">Abgerechnet</button>
      <button mat-stroked-button [class.active]="filter === 'all'" (click)="setFilter('all')">Alle</button>
    </div>
  </div>

  <div class="billing-layout">
    <section class="billing-list">
      <div class="list-toolbar">
        <h2>Kunden</h2>
        <button mat-icon-button (click)="loadOverview()" matTooltip="Aktualisieren">
          <mat-icon>refresh</mat-icon>
        </button>
      </div>

      <div class="loading-state" *ngIf="loading">
        <mat-spinner diameter="36"></mat-spinner>
      </div>

      <div class="empty-state" *ngIf="!loading && groups.length === 0">
        <mat-icon>task_alt</mat-icon>
        <p>Keine passenden Abrechnungsobjekte gefunden.</p>
      </div>

      <button type="button" class="customer-item" *ngFor="let group of groups; trackBy: trackByCustomerGroup" (click)="selectCustomer(group)" [class.active]="selectedCustomer?.key === group.key">
        <div class="item-main">
          <strong>{{group.customerName}}</strong>
          <span>{{group.billable.length}} abrechenbar · {{group.pending.length}} vorgemerkt</span>
          <small>{{group.openCount}} offen · {{group.billedCount}} abgerechnet</small>
        </div>
        <div class="item-side">
          <span class="count-pill">{{group.billable.length + group.pending.length}}</span>
          <strong>{{formatCurrency(group.totalNet || 0)}}</strong>
          <small *ngIf="group.unpricedCount > 0">{{group.unpricedCount}} ohne Preis</small>
        </div>
      </button>
    </section>

    <section class="billing-editor">
      <div class="editor-placeholder" *ngIf="!selectedCustomer && !selectedLoading">
        <mat-icon>receipt_long</mat-icon>
        <h2>Kunde auswählen</h2>
        <p>Links einen Kunden wählen, dann abrechenbare und vorgemerkte Einsätze prüfen.</p>
      </div>

      <div class="loading-state" *ngIf="selectedLoading">
        <mat-spinner diameter="42"></mat-spinner>
      </div>

      <ng-container *ngIf="selectedCustomer && !selectedLoading">
        <div class="customer-overview-header">
          <div>
            <span class="eyebrow">Kunde</span>
            <h2>{{selectedCustomer.customerName}}</h2>
          </div>
          <div class="customer-totals">
            <span>{{selectedCustomer.billable.length}} abrechenbar</span>
            <strong>{{formatCurrency(selectedCustomer.totalNet || 0)}}</strong>
          </div>
        </div>

        <div class="customer-job-section">
          <h3>Abrechenbar</h3>
          <p *ngIf="selectedCustomer.billable.length === 0" class="section-empty">Keine abgeschlossenen abrechenbaren Einsätze.</p>
          <button type="button" class="job-item billable" *ngFor="let item of selectedCustomer.billable; trackBy: trackByBillingItem" (click)="selectItem(item)" [class.active]="selected?.maintenanceId === item.maintenanceId">
            <div class="item-main">
              <strong>{{item.title}}</strong>
              <span>{{item.equipmentName || 'Keine Anlage'}} · {{item.completedOn || item.scheduledDate | date:'dd.MM.yyyy'}}</span>
              <small>{{item.lineCount}} Positionen · {{getStatusLabel(item)}}</small>
            </div>
            <div class="item-side">
              <span class="billing-chip" [class.billed]="item.billingStatus === MaintenanceBillingStatus.Billed">
                {{item.billingStatus === MaintenanceBillingStatus.Billed ? 'Abgerechnet' : 'Offen'}}
              </span>
              <strong>{{formatCurrency(item.netTotal || 0)}}</strong>
              <small *ngIf="item.unpricedLineCount > 0">{{item.unpricedLineCount}} ohne Preis</small>
            </div>
          </button>
        </div>

        <div class="customer-job-section pending">
          <h3>Vorgemerkt, noch nicht abgeschlossen</h3>
          <p *ngIf="selectedCustomer.pending.length === 0" class="section-empty">Keine offenen vorgemerkten Einsätze.</p>
          <button type="button" class="job-item" *ngFor="let item of selectedCustomer.pending; trackBy: trackByBillingItem" (click)="selectItem(item)" [class.active]="selected?.maintenanceId === item.maintenanceId">
            <div class="item-main">
              <strong>{{item.title}}</strong>
              <span>{{item.equipmentName || 'Keine Anlage'}} · {{item.scheduledDate | date:'dd.MM.yyyy'}}</span>
              <small>{{item.lineCount}} Positionen · {{getStatusLabel(item)}}</small>
            </div>
            <div class="item-side">
              <span class="billing-chip pending-chip">{{getStatusLabel(item)}}</span>
              <strong>{{formatCurrency(item.netTotal || 0)}}</strong>
              <small *ngIf="item.unpricedLineCount > 0">{{item.unpricedLineCount}} ohne Preis</small>
            </div>
          </button>
        </div>
      </ng-container>

      <ng-container *ngIf="selected && billing && !selectedLoading">
        <div class="editor-header">
          <div>
            <span class="eyebrow">{{selected.customerName}}</span>
            <h2>{{selected.title}}</h2>
            <p>{{selected.equipmentName}} · {{selected.completedOn || selected.scheduledDate | date:'dd.MM.yyyy'}}</p>
          </div>
          <mat-button-toggle-group [(ngModel)]="billingStatus" aria-label="Abrechnungsstatus">
            <mat-button-toggle [value]="MaintenanceBillingStatus.Open">Offen</mat-button-toggle>
            <mat-button-toggle [value]="MaintenanceBillingStatus.Billed">Abgerechnet</mat-button-toggle>
          </mat-button-toggle-group>
        </div>

        <div class="not-ready-hint" *ngIf="!isSelectedCompleted">
          <mat-icon>pending_actions</mat-icon>
          Dieser Einsatz ist noch nicht abgeschlossen. Positionen können vorbereitet werden, Rechnung und Abrechnung sind erst nach Abschluss möglich.
        </div>

        <div class="summary-cards">
          <div>
            <span>Netto</span>
            <strong>{{formatCurrency(netTotal)}}</strong>
          </div>
          <div>
            <span>Positionen</span>
            <strong>{{includedLines.length}}</strong>
          </div>
          <div [class.warning]="unpricedIncludedLines > 0">
            <span>Ohne Preis</span>
            <strong>{{unpricedIncludedLines}}</strong>
          </div>
        </div>

        <mat-expansion-panel class="invoice-template-panel">
          <mat-expansion-panel-header>
            <mat-panel-title>Rechnung & PDF-Vorlage</mat-panel-title>
            <mat-panel-description>Empfänger, Kontakte und Anhang</mat-panel-description>
          </mat-expansion-panel-header>

          <div class="template-grid">
            <mat-form-field appearance="outline" *ngIf="customerContacts.length > 0">
              <mat-label>Rechnungsperson</mat-label>
              <mat-select [(ngModel)]="invoiceDraft.invoiceContactId" (selectionChange)="applyInvoiceContact()">
                <mat-option [value]="null">Keine Person verwenden</mat-option>
                <mat-option *ngFor="let contact of customerContacts; trackBy: trackByContact" [value]="contact.id ?? null">
                  {{contact.fullName}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Rechnungsempfänger</mat-label>
              <input matInput [(ngModel)]="invoiceDraft.invoiceName">
            </mat-form-field>

            <mat-form-field appearance="outline" class="wide">
              <mat-label>Rechnungsadresse</mat-label>
              <textarea matInput rows="2" [(ngModel)]="invoiceDraft.invoiceAddress"></textarea>
            </mat-form-field>

            <mat-form-field appearance="outline" *ngIf="customerContacts.length > 0">
              <mat-label>Versandperson</mat-label>
              <mat-select [(ngModel)]="invoiceDraft.shippingContactId" (selectionChange)="applyShippingContact()">
                <mat-option [value]="null">Keine Person verwenden</mat-option>
                <mat-option *ngFor="let contact of customerContacts; trackBy: trackByContact" [value]="contact.id ?? null">
                  {{contact.fullName}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Versandempfänger</mat-label>
              <input matInput [(ngModel)]="invoiceDraft.shippingName">
            </mat-form-field>

            <mat-form-field appearance="outline" class="wide">
              <mat-label>Versandadresse</mat-label>
              <textarea matInput rows="2" [(ngModel)]="invoiceDraft.shippingAddress"></textarea>
            </mat-form-field>

            <mat-form-field appearance="outline" *ngIf="customerContacts.length > 0">
              <mat-label>Projekt / Ansprechpartner</mat-label>
              <mat-select [(ngModel)]="invoiceDraft.projectContactId" (selectionChange)="applyProjectContact()">
                <mat-option [value]="null">Keine Person verwenden</mat-option>
                <mat-option *ngFor="let contact of customerContacts; trackBy: trackByContact" [value]="contact.id ?? null">
                  {{contact.fullName}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Projektleiter</mat-label>
              <input matInput [(ngModel)]="invoiceDraft.projectManagerName">
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Projektleiter E-Mail</mat-label>
              <input matInput [(ngModel)]="invoiceDraft.projectManagerEmail">
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Kunden-Nr.</mat-label>
              <input matInput [(ngModel)]="invoiceDraft.customerNumber">
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>UID</mat-label>
              <input matInput [(ngModel)]="invoiceDraft.vatId">
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Ihre Bestellung</mat-label>
              <input matInput [(ngModel)]="invoiceDraft.orderNumber">
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Bestelldatum</mat-label>
              <input matInput type="date" [(ngModel)]="invoiceDraft.orderDate">
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Projekt-Nr.</mat-label>
              <input matInput [(ngModel)]="invoiceDraft.projectNumber">
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Zahlungsbedingungen</mat-label>
              <input matInput [(ngModel)]="invoiceDraft.paymentTerms">
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Lieferbedingungen</mat-label>
              <input matInput [(ngModel)]="invoiceDraft.deliveryTerms">
            </mat-form-field>

            <mat-form-field appearance="outline" class="wide">
              <mat-label>Rechnungsnotiz</mat-label>
              <textarea matInput rows="2" [(ngModel)]="invoiceDraft.invoiceNote"></textarea>
            </mat-form-field>
          </div>

          <div class="template-actions">
            <mat-checkbox [(ngModel)]="invoiceDraft.includeServiceAppendix">Einsatzübersicht anhängen</mat-checkbox>
            <button mat-stroked-button type="button" (click)="saveInvoiceTemplate()" [disabled]="savingTemplate || !selectedCustomerDetails">
              <mat-spinner *ngIf="savingTemplate" diameter="18"></mat-spinner>
              <mat-icon *ngIf="!savingTemplate">save_as</mat-icon>
              Als Kundenvorlage speichern
            </button>
          </div>
        </mat-expansion-panel>

        <div class="line-table">
          <div class="line-row line-head">
            <span>Typ</span>
            <span>Beschreibung</span>
            <span>Menge</span>
            <span>Einheit</span>
            <span>Preis</span>
            <span>Summe</span>
            <span></span>
          </div>
          <div class="line-row" *ngFor="let line of draftLines; let i = index; trackBy: trackByLine" [class.excluded]="!line.isIncluded">
            <span class="source-pill">{{getSourceLabel(line)}}</span>
            <mat-form-field appearance="outline">
              <mat-label>Beschreibung</mat-label>
              <input matInput [(ngModel)]="line.description">
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Menge</mat-label>
              <input matInput type="number" min="0" step="0.01" [(ngModel)]="line.quantity">
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Einheit</mat-label>
              <input matInput [(ngModel)]="line.unit">
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>€/Einheit</mat-label>
              <input matInput type="number" min="0" step="0.01" [(ngModel)]="line.unitPrice">
            </mat-form-field>
            <strong>{{formatCurrency(getLineTotal(line))}}</strong>
            <div class="row-actions">
              <mat-checkbox [(ngModel)]="line.isIncluded" matTooltip="In Rechnung aufnehmen"></mat-checkbox>
              <button mat-icon-button (click)="moveLine(i, -1)" [disabled]="i === 0" matTooltip="Nach oben">
                <mat-icon>keyboard_arrow_up</mat-icon>
              </button>
              <button mat-icon-button (click)="moveLine(i, 1)" [disabled]="i === draftLines.length - 1" matTooltip="Nach unten">
                <mat-icon>keyboard_arrow_down</mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="removeLine(i)" matTooltip="Position entfernen">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>
          </div>
        </div>

        <div class="add-line">
          <mat-form-field appearance="outline" class="description-field">
            <mat-label>Neue Position</mat-label>
            <input matInput [(ngModel)]="newLine.description" placeholder="z.B. Kleinmaterial">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Menge</mat-label>
            <input matInput type="number" min="0" step="0.01" [(ngModel)]="newLine.quantity">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Einheit</mat-label>
            <input matInput [(ngModel)]="newLine.unit">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>€/Einheit</mat-label>
            <input matInput type="number" min="0" step="0.01" [(ngModel)]="newLine.unitPrice">
          </mat-form-field>
          <button mat-mini-fab color="primary" (click)="addManualLine()" [disabled]="!newLine.description.trim()">
            <mat-icon>add</mat-icon>
          </button>
        </div>

        <mat-form-field appearance="outline" class="note-field">
          <mat-label>Kaufmännische Notiz</mat-label>
          <textarea matInput rows="2" [(ngModel)]="billingNote"></textarea>
        </mat-form-field>

        <div class="editor-actions">
          <button mat-stroked-button (click)="generateInvoicePdf()" [disabled]="includedLines.length === 0 || !isSelectedCompleted">
            <mat-icon>picture_as_pdf</mat-icon>
            Rechnung PDF
          </button>
          <button mat-stroked-button (click)="markOpen()" [disabled]="saving || billingStatus === MaintenanceBillingStatus.Open">
            <mat-icon>undo</mat-icon>
            Wieder offen
          </button>
          <button mat-raised-button color="primary" (click)="save()" [disabled]="saving">
            <mat-spinner *ngIf="saving" diameter="18"></mat-spinner>
            <mat-icon *ngIf="!saving">save</mat-icon>
            Speichern
          </button>
          <button mat-raised-button color="accent" (click)="markBilledAndCreateInvoice()" [disabled]="saving || includedLines.length === 0 || !isSelectedCompleted">
            <mat-icon>receipt_long</mat-icon>
            Rechnung erstellen & abrechnen
          </button>
        </div>
      </ng-container>
    </section>
  </div>
</div>
